import {forwardRef, useImperativeHandle, useState} from "react";
import {Button, Modal} from "antd";
import {IconClose} from "../../../../Icon";
import {useTranslation} from "react-i18next";
import {isZh} from "@/language";
import {ipcSend} from "@/common/ipc";

const DialogUpdate = forwardRef((props:{onStartUpdateEvent:any,onSkipUpdate:any}, ref) => {
    useImperativeHandle(ref,()=>({
        onShowDialog:onShowDialog
    }))
    const {t} = useTranslation();
    const [isShowDialog,setIsShowDialog] = useState(false);

    const onShowDialog = ()=>{
        setIsShowDialog(true)
    }

    return(
        <Modal width='448px' open={isShowDialog} closeIcon={<IconClose/>} centered={true} footer={
            <div className={'flex-row-vertical-center'}>
                <div className='flex-center button-border-gray-style' onClick={()=> {
                    setIsShowDialog(false);
                    props.onSkipUpdate();
                }} style={{height:'30px',padding:'0 6px',minWidth:'114px',marginLeft:'auto'}}>{t("Skip this update")}</div>
                <div className='button-solid-style ml-12 flex-center' onClick={()=>{
                    setIsShowDialog(false);
                    props.onStartUpdateEvent();
                }} style={{height:'30px',padding:'0 6px',minWidth:'114px'}}>{t("Install")}</div>
            </div>
        } onCancel={(e)=>{
            setIsShowDialog(false);
        }}>
            <div style={{display:'flex',flexDirection:'column',marginBottom:'22px'}}>
                <span className='font-weight-500 font-size-14'>{t("New Version Available")}</span>
                <a className='link-color mt-6' style={{fontSize:'12px'}} href='javascript:void(0)' onClick={(e)=>{
                    if (isZh()) {
                        ipcSend('open-url', import.meta.env.VITE_HTTP_CHANGE_LOG_ZH);
                    } else {
                        ipcSend('open-url', import.meta.env.VITE_HTTP_CHANGE_LOG);
                    }
                }}>{t("See whats new")}</a>
            </div>

        </Modal>
    )
})

export default DialogUpdate;